import { Search, ShoppingBag, Menu } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

const Header = ({ searchValue, onSearchChange, onOpenFilters }) => {
  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-40 w-full backdrop-blur-md bg-[hsl(var(--background))]/80 border-b border-border/60"
    >
      <div className="mx-auto max-w-[1400px] px-5 lg:px-10">
        <div className="flex items-center justify-between h-16 lg:h-20 gap-6">
          {/* Left: mobile filters */}
          <Button
            data-testid="mobile-filters-btn"
            variant="ghost"
            size="icon"
            className="lg:hidden"
            onClick={onOpenFilters}
            aria-label="Open filters"
          >
            <Menu className="w-5 h-5" />
          </Button>

          {/* Brand */}
          <a
            href="/"
            data-testid="brand-logo"
            className="flex items-center gap-3 leading-none"
          >
            <img
              src="/api/static/marketing/kays-logo.png"
              alt="Kay's Beauty Hair"
              className="h-10 sm:h-12 lg:h-14 w-auto"
            />
            <div className="flex flex-col leading-[0.9]">
              <span
                className="font-serif text-3xl sm:text-4xl lg:text-5xl"
                style={{ color: "#C77F6F" }}
              >
                Kay&apos;s
              </span>
              <span
                className="font-bold tracking-wider text-[10px] sm:text-xs lg:text-sm uppercase mt-1"
                style={{ color: "#5A3825", letterSpacing: "0.12em" }}
              >
                Beauty Hair
              </span>
            </div>
          </a>

          {/* Search */}
          <div className="hidden md:flex flex-1 max-w-sm relative">
            <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
            <Input
              data-testid="search-input"
              value={searchValue}
              onChange={(e) => onSearchChange(e.target.value)}
              placeholder="Search wigs, colors, styles…"
              className="pl-9 bg-white/70 border-border/70 h-10 rounded-sm placeholder:text-muted-foreground/70"
            />
          </div>

          {/* Right */}
          <div className="flex items-center gap-2">
            <a
              data-testid="shop-on-shopify-link"
              href="https://kays-beauty-hair.myshopify.com"
              target="_blank"
              rel="noopener noreferrer"
              className="hidden sm:inline-flex items-center gap-2 text-sm text-foreground/80 hover:text-[hsl(var(--primary))] transition-colors link-underline"
            >
              <ShoppingBag className="w-4 h-4" />
              Visit Shop
            </a>
          </div>
        </div>

        {/* Mobile search */}
        <div className="md:hidden pb-3 relative">
          <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
          <Input
            data-testid="search-input-mobile"
            value={searchValue}
            onChange={(e) => onSearchChange(e.target.value)}
            placeholder="Search wigs, colors, styles…"
            className="pl-9 bg-white/70 border-border/70 h-10 rounded-sm"
          />
        </div>
      </div>
    </header>
  );
};

export default Header;
